import React, { useContext, useEffect, useState } from 'react';
import DesktopNavBar from '../navigation/DesktopNavBar';
import MobileNavBar from '../navigation/MobileNavBar';
import SessionContext from '../../store/SessionContext';

const Layout = props => {

    const session = useContext(SessionContext);

    //  >>  WINDOW DIMENSIONS FOR MOBILE NAV
    const [windowDimension, setWindowDimension] = useState(null);

    useEffect(() => {
        setWindowDimension(window.innerWidth);
    }, []);
    useEffect(() => {
        const windowResizeHandler = () => {
            setWindowDimension(window.innerWidth);
        }
        window.addEventListener("resize", windowResizeHandler);
        return () => window.removeEventListener("resize", windowResizeHandler)
    }, [])

    const ActiveNav = () => {
        if (windowDimension < 1081) {
            return (<MobileNavBar />)
        } else {
            return (<DesktopNavBar />)
        }
    }

    return (
        <React.Fragment>
            {session.isLoggedIn && <ActiveNav />}
            {props.children}
        </React.Fragment>
    )
}

export default Layout;
